import { ApiService } from './api.service';
import { Injectable } from '@angular/core';
import { MarketingModel } from '../models/marketing.model';
import { Router } from '@angular/router';
import { Headers, RequestOptions } from '@angular/http';

@Injectable()
export class MarketingService {

    searching:boolean = false;
    errorFile:boolean = false;

    constructor(public apiService: ApiService, private router:Router) {

    }

    public search(marketing: MarketingModel, results:any, component:any) {

        let data = {
            hasMobile   : 'false',
            hasAdress   : 'false',
            hasMail     : 'false',
            male        : (marketing.male).toString(),
            female      : (marketing.female).toString(),
            interested  : {},
            depensed    : '0'
        };

        if (marketing.type == 'mobile'){
            data.hasMobile = 'true';
        }
        if (marketing.type == 'adress'){
            data.hasAdress = 'true';
        }
        if (marketing.type == 'mail'){
            data.hasMail = 'true';
        }


        if (marketing.depensed)
            data.depensed = marketing.depensed.toString();

        if (marketing.serviceSince)
            data['serviceSince'] = new Date(marketing.serviceSince);
        if (marketing.serviceNotSince)
            data['serviceNotSince'] = new Date(marketing.serviceNotSince);
        if (marketing.clientSince)
            data['clientSince'] = new Date(marketing.clientSince);
        if (marketing.listCode.length > 0)
            data['codes'] = marketing.listCode;
        if (marketing.listBrand.length > 0)
            data['bikeBrand'] = marketing.listBrand;
        if (marketing.listModel.length > 0)
            data['bikeModel'] = marketing.listModel;

        if (!marketing.looser)
            data['looser'] = 'false';

        if (marketing.interestedRun)
            data.interested['run'] = (marketing.interestedRun).toString();
        if (marketing.interestedVtt !== 'false')
            data.interested['vtt'] = (marketing.interestedVtt).toString();
        if (marketing.interestedAccessory)
            data.interested['accessory'] = (marketing.interestedAccessory).toString();
        if (marketing.interestedService)
            data.interested['service'] = (marketing.interestedService).toString();
        if (marketing.interestedAubonne)
            data.interested['aubonne'] = (marketing.interestedAubonne).toString();
        if (marketing.interestedGeneve)
            data.interested['geneve'] = (marketing.interestedGeneve).toString();
        if (marketing.interestedCyclocross)
            data.interested['cyclocross'] = (marketing.interestedCyclocross).toString();

        this.searching = true;
        this.apiService.post('campagneSearch', data).subscribe((_res)=> {
            if (results)
                results.length = 0;
            _res.data.forEach((e) => {
                e.activate = true;
                results.push(e);
            });
            this.searching = false;
            marketing.typeSearch = marketing.type;
            component.calculatePrice();
        }, (_err)=> {
            this.searching = false;
            this.apiService.error(_err);
        });
    }

    public sendSMS(name:string, customers:string[], message:string) {
        this.apiService.post('campagne', {name:name, clients: customers, message:message}).subscribe((_res)=> {
            this.router.navigate(['marketing', 'old']);
        }, (_err)=> {
            this.apiService.error(_err);
        });
    }

    public sendMail(name:string, customers:string[]) {
        this.apiService.post('campagneMail', {name:name, clients: customers, message:''}).subscribe((_res)=> {
            this.router.navigate(['marketing', 'old']);
        }, (_err)=> {
            this.apiService.error(_err);
        });
    }

    public sendLetter(name:string, customers:string, file, category) {
        let headersCustom: Headers     = new Headers;
        let optionsCustom: RequestOptions;
        let formData:FormData = new FormData();

        formData.append('name', name);
        formData.append('stringClients', customers);
        formData.append('categorie', category);
        formData.append('file', file, file.name);
        optionsCustom = new RequestOptions({
            headers: headersCustom
        });

        this.errorFile = false;

        this.apiService.postWithFile('campagneLetter', formData, optionsCustom).subscribe((_res)=> {
            this.router.navigate(['marketing', 'old']);
        }, (_err)=> {
            this.errorFile = true;
            this.apiService.error(_err);
        });
    }

    public getOld(results:any[]) {
        this.apiService.get('campagnes', '').subscribe((_res)=> {
            if (results.length)
                results.length = 0;
            _res.data.forEach((r) => {
                results.unshift(r);
            });
        }, (_err)=> {
            this.apiService.error(_err);
        });
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/home/services/marketing.service.ts